import { subDays } from 'date-fns';
import type { Filters } from './consts';

export function minPostedAtForDateRange(dateRange: Filters['dateRange'], now = new Date()): Date {
    if (dateRange === 'day') return subDays(now, 1);
    if (dateRange === 'week') return subDays(now, 7);
    return subDays(now, 30);
}
